<template>
  <div inline>
    <div
      class="ability--head"
      :style="{ 'background-color': ability.Color }"
      style="width: 100%">
      <img
        v-if="ability.HasIcon"
        :src="ability.Icon"
        style="height: 1.5em" />
      <span v-if="ability.HasIcon">&nbsp;</span>
      <display-tooltip-text :string="ability.Header" />

      <span
        v-if="ability.Origin"
        style="margin-left: auto; order: 2; padding-right: 1em; font-weight: 1">
        <i>
          <display-tooltip-text :string="'From: _' + ability.Origin.Name + '_'" />
        </i>
      </span>
    </div>
    <div
      class="card--keywords"
      style="padding-left: 0.5em; padding-top: 0.5em; font-size: smaller"
      v-if="ability.HasKeywords">
      <b>
        <span
          v-for="(keyword, index) in ability.Keywords"
          :key="index"
          class="keyword--box">
          <display-tooltip-text
            :string="keyword"
            :decorate="false" />
        </span>
      </b>
    </div>
    <div class="card--content card--format">
      <div
        v-if="ability.Desc.length > 0 && showDesc"
        style="font-style: italic; font-size: smaller">
        {{ ability.Desc }}<br />
      </div>
      <div v-if="ability.HasHeadline">
        <display-tooltip-text :string="ability.Headline" />
      </div>
      <div v-if="ability.HasBlock || ability.HasGuard">
        <display-tooltip-text :string="ability.ArmorSummary" />
      </div>
      <div
        v-if="isStance"
        class="chart--wrapper"
        inline>
        <v-row
          align="stretch"
          no-gutters
          class="chart--row">
          <v-col
            class="chart--head"
            :cols="2">
            <b>
              <display-tooltip-text
                string="_Phase_"
                :decorate="false" />
            </b>
          </v-col>
          <v-col
            class="chart--head"
            :cols="2">
            <b>
              <display-tooltip-text
                string="_Momentum_"
                :decorate="false" />
            </b>
          </v-col>
          <v-col
            class="chart--head"
            :cols="2">
            <b>
              <display-tooltip-text
                string="_Essence_"
                :decorate="false" />
            </b>
          </v-col>
          <v-col
            class="chart--head"
            :cols="2">
            <b>
              <display-tooltip-text
                string="_Speed_"
                :decorate="false" />
            </b>
          </v-col>
          <v-col
            class="chart--head"
            :cols="2">
            <b>
              <display-tooltip-text
                string="_Block_"
                :decorate="false" />
            </b>
          </v-col>
        </v-row>
        <v-row
          align="stretch"
          no-gutters
          class="chart--row">
          <v-col
            class="chart--cols justify-center align-center"
            :cols="2"
            >{{ ability.Phase }}</v-col
          >
          <v-col
            class="chart--cols justify-center align-center"
            :cols="2"
            >{{ ability.Momentum }}</v-col
          >
          <v-col
            class="chart--cols justify-center align-center"
            :cols="2"
            >0</v-col
          >
          <v-col
            class="chart--cols justify-center align-center"
            :cols="2"
            >+{{ ability.Speed }}</v-col
          >
          <v-col
            class="chart--cols justify-center align-center"
            :cols="2"
            >+{{ ability.Block }}</v-col
          >
        </v-row>
      </div>
      <div v-if="ability.HasPrereqs">
        <display-tooltip-text :string="ability.PrereqsHeader" />
      </div>
      <div v-if="ability.HasCost">
        <display-tooltip-text :string="ability.CostHeader" />
      </div>
      <div v-if="ability.HasFrequency">
        <display-tooltip-text :string="ability.FrequencyHeader" />
      </div>
      <div v-if="ability.HasRangeOrTarget">
        <display-tooltip-text :string="ability.RangeOrTargetHeader" />
      </div>
      <div v-if="ability.HasTrigger">
        <display-tooltip-text :string="ability.TriggerHeader" />
      </div>
      <div v-if="ability.HasMissile">
        <display-tooltip-text :string="ability.MissileHeader" />
      </div>
      <div v-if="ability.ShouldDisplayMaterialDamageHeader">
        <display-tooltip-text :string="ability.MaterialDamageTypeHeader" />
      </div>
      <div v-if="ability.HasSource">
        <display-tooltip-text :string="ability.SourceHeader" />
      </div>
      <div v-if="ability.HasHardness">
        <display-tooltip-text :string="ability.HardnessHeader" />
      </div>
      <div v-if="ability.HasEffect">
        <display-tooltip-text :string="ability.EffectHeader" />
      </div>
      <div v-if="ability.HasSpecial">
        <display-tooltip-text :string="ability.SpecialHeader" />
      </div>
      <div v-if="ability.HasEnter">
        <display-tooltip-text :string="ability.EnterHeader" />
      </div>
      <div v-if="ability.HasCollide">
        <display-tooltip-text :string="ability.CollideHeader" />
      </div>
      <div v-if="ability.HasEngaged">
        <display-tooltip-text :string="ability.EngagedHeader" />
      </div>
      <div v-if="ability.HasRepeat">
        <display-tooltip-text :string="ability.RepeatHeader" />
      </div>
      <div v-if="ability.HasEor">
        <display-tooltip-text :string="ability.EorHeader" />
      </div>
      <div v-if="ability.HasNegate">
        <display-tooltip-text :string="ability.NegateHeader" />
      </div>
      <div v-if="ability.HasReacts">
        <display-tooltip-text :string="ability.ReactsHeader" />
      </div>
      <div v-if="ability.HasRemove">
        <display-tooltip-text :string="ability.RemoveHeader" />
      </div>
      <div v-if="ability.HasRecovery">
        <display-tooltip-text :string="ability.RecoveryHeader" />
      </div>
      <div v-if="ability.HasNegate">
        <display-tooltip-text :string="ability.NegateHeader" />
      </div>
      <div v-if="ability.HasDestroy">
        <display-tooltip-text :string="ability.DestroyHeader" />
      </div>
      <div v-if="ability.HasInteractions">
        <display-tooltip-text :string="ability.InteractionsHeader" />
      </div>
      <div v-if="ability.HasEnhancements">
        <display-tooltip-text :string="ability.EnhancementsHeader" />
      </div>
      <div v-if="ability.HasImbues">
        <display-tooltip-text :string="ability.ImbuesHeader" />
      </div>
      <div
        v-if="isAbilityPackage"
        v-bind:class="useTextFormatting"
        class="ability-box"
        style="padding-bottom: 0.25em"
        v-bind:style="isStance ? {} : 'padding-left: 3em'">
        <base-widget
          v-for="ability in ability.Abilities"
          :ability="ability"
          :key="ability.Name"
          :showChart="showChart" />
        <base-widget
          v-for="stance in ability.Stances"
          :ability="stance"
          :key="stance.Name"
          :showChart="showChart" />
      </div>
      <div
        class="expand--collapse-box-outlined"
        v-if="ability.HasChart">
        <v-expansion-panels
          v-if="!showChart"
          class="condensed"
          flat
          tile
          style="width: 100%">
          <v-expansion-panel style="background-color: inherit">
            <v-expansion-panel-header class="expand--header-chart">Chart</v-expansion-panel-header>
            <v-expansion-panel-content class="expand--body-chart">
              <chart-table :chart="ability.Chart" />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <chart-table
          v-else
          :chart="ability.Chart" />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { AbilityPackage, Armor, Base, Equipment, Weapon, Stance, Status, Terrain } from '@/class'
import { store } from '@/store'
import AbilityWidget from '@/components/AbilityWidget.vue'
import BasicTable from '@/components/BasicTable.vue'
import ChartTable from '@/components/ChartTable.vue'

export default Vue.extend({
  name: 'base-widget',
  props: {
    ability: {
      type: Base,
      required: true,
    },
    format_text: {
      type: Boolean,
      default: false,
    },
    standalone: {
      type: Boolean,
      default: false,
    },
    showChart: {
      type: Boolean,
      default: false,
    },
    showDesc: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    useTextFormatting: function () {
      if (this.format_text) return 'card--text-format'
    },
    isAbilityPackage() {
      return this.ability instanceof AbilityPackage
    },
    isStance() {
      return this.ability instanceof Stance
    },
  },
  components: { AbilityWidget, BasicTable, ChartTable },
})
</script>

<style scoped lang="scss"></style>
